export default "__VITE_ASSET__DidpM7F5__"